import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about/index.vue')
  },
  {
    path: '/about/introduction',
    name: 'AboutIntroduction',
    component: () => import('@/views/about/introduction/index.vue')
  },
  {
    path: '/about/team',
    name: 'AboutTeam',
    component: () => import('@/views/about/team/index.vue')
  },
  {
    path: '/about/contact',
    name: 'AboutContact',
    component: () => import('@/views/about/contact/index.vue')
  },
  {
    path: '/about/join',
    name: 'AboutJoin',
    component: () => import('@/views/about/join/index.vue')
  },
  {
    path: '/celebrities',
    name: 'Celebrities',
    component: () => import('@/views/celebrities/index.vue')
  },
  {
    path: '/celebrities/ancient',
    name: 'CelebritiesAncient',
    component: () => import('@/views/celebrities/ancient/index.vue')
  },
  {
    path: '/celebrities/modern',
    name: 'CelebritiesModern',
    component: () => import('@/views/celebrities/modern/index.vue')
  },
  {
    path: '/celebrities/stories',
    name: 'CelebritiesStories',
    component: () => import('@/views/celebrities/stories/index.vue')
  },
  {
    path: '/celebrity/:id',
    name: 'CelebrityDetail',
    component: () => import('@/views/celebrities/detail.vue')
  },
  {
    path: '/citang',
    alias: '/temples',
    name: 'Temples',
    component: () => import('@/views/temples/index.vue')
  },
  {
    path: '/citang/:id',
    alias: '/temple/:id',
    name: 'TempleDetail',
    component: () => import('@/views/temples/detail.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/news/index.vue')
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/news/detail.vue')
  },
  {
    path: '/interaction',
    name: 'Interaction',
    component: () => import('@/views/interaction/index.vue')
  },
  {
    path: '/interaction/forum',
    name: 'InteractionForum',
    component: () => import('@/views/interaction/forum/index.vue')
  },
  {
    path: '/interaction/signup',
    name: 'InteractionSignup',
    component: () => import('@/views/interaction/signup/index.vue')
  },
  {
    path: '/interaction/vote',
    name: 'InteractionVote',
    component: () => import('@/views/interaction/vote/index.vue')
  },
  {
    path: '/origin',
    name: 'Origin',
    component: () => import('@/views/origin/index.vue')
  },
  {
    path: '/culture',
    name: 'Culture',
    component: () => import('@/views/culture/index.vue')
  },
  {
    path: '/stories',
    name: 'Stories',
    component: () => import('@/views/stories/index.vue')
  },
  {
    path: '/distribution',
    name: 'Distribution',
    component: () => import('@/views/distribution/index.vue')
  },
  {
    path: '/genealogy/national',
    name: 'GenealogyNational',
    component: () => import('@/views/genealogy/national.vue')
  },
  {
    path: '/genealogy/local',
    name: 'GenealogyLocal',
    component: () => import('@/views/genealogy/local.vue')
  },
  {
    path: '/genealogy/analysis',
    name: 'GenealogyAnalysis',
    component: () => import('@/views/genealogy/analysis.vue')
  },
  {
    path: '/relic/showcase',
    name: 'RelicShowcase',
    component: () => import('@/views/relic/showcase.vue')
  },
  {
    path: '/relic/stories',
    name: 'RelicStories',
    component: () => import('@/views/relic/stories.vue')
  },
  {
    path: '/relic/protection',
    name: 'RelicProtection',
    component: () => import('@/views/relic/protection.vue')
  },
  {
    path: '/clan/directory',
    name: 'ClanDirectory',
    component: () => import('@/views/clan/directory/index.vue')
  },
  {
    path: '/clan/activities',
    name: 'ClanActivities',
    component: () => import('@/views/clan/activities/index.vue')
  },
  {
    path: '/clan/guestbook',
    name: 'ClanGuestbook',
    component: () => import('@/views/clan/guestbook/index.vue')
  },
  {
    path: '/dictionary/terms',
    name: 'DictionaryTerms',
    component: () => import('@/views/dictionary/terms/index.vue')
  },
  {
    path: '/dictionary/encyclopedia',
    name: 'DictionaryEncyclopedia',
    component: () => import('@/views/dictionary/encyclopedia/index.vue')
  },
  {
    path: '/dictionary/generation',
    name: 'DictionaryGeneration',
    component: () => import('@/views/dictionary/generation/index.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/contact/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/user/login.vue'),
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/user/register.vue'),
    meta: { guest: true }
  },
  {
    path: '/center',
    name: 'Center',
    component: () => import('@/views/center/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/center/index',
    redirect: '/center'
  },
  {
    path: '/center/address',
    name: 'CenterAddress',
    component: () => import('@/views/center/address.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/center/password',
    name: 'CenterPassword',
    component: () => import('@/views/center/password.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/center/tree',
    name: 'CenterTree',
    component: () => import('@/views/center/tree.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/search/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  console.log('【路由守卫】导航到:', to.path, 'token存在:', !!token)
  
  if (to.meta.requiresAuth && !token) {
    console.log('【路由守卫】需要登录，重定向到登录页')
    next('/login')
  } else if (to.meta.guest && token) {
    console.log('【路由守卫】已登录，重定向到个人中心')
    next('/center')
  } else {
    next()
  }
})

export default router
